import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { TenantPermissionDto } from 'projects/shared/src/lib/models/PermissionForCreationDto';
import { TenantGroupRoleDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { PermissionsService } from 'projects/shared/src/lib/services/permissions.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'tenant-permissions',
  templateUrl: './tenant-permissions.component.html',
  styleUrls: ['./tenant-permissions.component.css']
})

export class TenantPermissionsComponent implements OnInit {

  //platformPermissionForm!: FormGroup;

  //platformGroupRolePermissions: PlatformGroupRolePermissionDto[] = [];

  tenantPermissions: TenantPermissionDto[] = [];
  actTenantGroupRole!: TenantGroupRoleDto;
  tenantRoles: string[] = [];
  groupRoleName!: string;
  tenantName!: string;

  constructor(public _dialogRef: MatDialogRef<TenantPermissionsComponent>,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    private permissionService: PermissionsService) { }

  ngOnInit(): void {
    //this.platformGroupRolePermissions = this.data.platformGroupRolePermissions;
    this.actTenantGroupRole = this.data.tenantGroupRole;
    this.tenantRoles = this.data.tenantRoles;
    this.tenantName = this.data.tenantName;
    // if (this.tenantService.currentTenantName == "DEMOZUGANG")
    //   this.tenantRoles.push("CREATE_DEMOUSER");
    console.log("----------> tenant-permissions tenantRoles ",this.tenantRoles);
    this.groupRoleName = this.actTenantGroupRole.name;
    // this._tenantName = localStorage.getItem('current-tenant-name') as string;
    //this._tenantName = this.tenantService.currentTenantName;

    this.mapPlatformPermissions()
  }

  mapPlatformPermissions() {

    console.log("------> load tenant permissions");

    // all possible permissions
    this.permissionService.loadTenantPermissions(this.tenantName, new GenericFilter()).subscribe({
      next:(permissionDtos:any) => { 
        console.log("--------------> tenant Permissions", permissionDtos)
        this.tenantPermissions = permissionDtos;
        if (this.actTenantGroupRole.permissions != null) {
          let permArrayRole = this.actTenantGroupRole.permissions.split(",");
          let permArrayTenant = this.tenantPermissions;
          permArrayTenant.forEach(function (tenantPerm) {
            permArrayRole.forEach(function (rolePerm) {
              if (rolePerm == tenantPerm.name) tenantPerm.permissionValue = true;
            })
          }) 
        }
      }
    })
  }
  
  // onChange(platformGroupRolePermission: PlatformGroupRolePermissionDto, event: MatSlideToggleChange) {

  //   this.platformGroupRoleService.updatePlatformGroupRolePermission(platformGroupRolePermission).subscribe({
  //     next:() => {
  //       this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PLATFORMGROUPROLEPERMISSIONUPDATED"]} `);
  //     },
  //     error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEPERMISSIONUPDATEDERROR"]}`)
  //   });
  // }

  onChange1(permissions: string) {
    console.log("--------> platform-permission change")
    console.log("tenant = ", this.tenantName)
    //this.platformPermissions = platformPermissions;
    this.actTenantGroupRole.permissions = permissions;
    //const tenantDb = localStorage.getItem('current-tenant-db') as string;


    this.tenantService.updateTenantGroupRole(this.tenantName, this.actTenantGroupRole).subscribe({
      next:() => {
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEPERMISSIONUPDATED"]} `);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEPERMISSIONUPDATEDERROR"]}`)
    });
  }

  cancel(){
    this._dialogRef.close();
  }
}